import React, { useCallback, useEffect, useState } from "react";
import {
  getInitialState,
  setOrg,
  getOrgs,
  handleItemChanged,
  handleItemsChanged,
} from "../utilities/orgsHelpers";
import "../App.css";
import { DxItemGroup } from "genesys-react-components";

const Orgs = ({ setAuthenticate }) => {
  const [orgs, setOrgs] = useState(() => getInitialState("orgs", []));
  const [selectedOrg, setSelectedOrg] = useState(() =>
    getInitialState("selectedOrg", { label: "SBC", value: "SBC" })
  );

  const memoizedSetOrg = useCallback(() => setOrg(selectedOrg), [selectedOrg]);

  useEffect(() => {
    if (orgs.length === 0) {
      getOrgs(setOrgs);
    }
  }, [orgs]);

  useEffect(() => {
    if (selectedOrg) {
      localStorage.setItem("selectedOrg", JSON.stringify(selectedOrg));
      memoizedSetOrg();
      setAuthenticate(selectedOrg.value);
    }
  }, [selectedOrg, memoizedSetOrg, setAuthenticate]);

  const memoizedHandleItemChanged = useCallback(
    (item, isSelected) => handleItemChanged(item, isSelected, setSelectedOrg),
    []
  );

  const memoizedHandleItemsChanged = useCallback(
    (items) => handleItemsChanged(orgs, selectedOrg),
    [orgs, selectedOrg]
  );

  return (
    <>
      {orgs.length > 0 && (
        <DxItemGroup
          title="Orgs:"
          items={orgs}
          format="dropdown"
          onItemChanged={memoizedHandleItemChanged}
          onItemsChanged={memoizedHandleItemsChanged}
        />
      )}
    </>
  );
};

export default Orgs;
